import React from 'react';
import { Community } from 'store/community/type';
import { calculateTimeStamp } from 'utils';
import { useRouter } from 'next/router';
import { getEndEventTime } from 'utils/event';
import styled from 'styled-components';

const Container = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

interface IProps {
  feed: Community;
  detail?: boolean;
}

const EventCard: React.FC<IProps> = ({ feed, detail }: IProps) => {
  const router = useRouter();

  const content = feed.content.replace(/<[^>]+>/g, '');
  const textClass = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '20px',
    height: '40px',
  };

  const clickDetail = id => {
    router.push(`/community/event/${id}`);
  };

  return (
    <div className="event-bnr">
      <a
        style={{
          backgroundImage:
            feed.images.length > 0 ? `url(${feed.images[0].image})` : 'unset',
          backgroundColor: feed.images.length > 0 ? 'unset' : '#f77f46',
          cursor: 'pointer',
        }}
        onClick={!detail ? () => clickDetail(feed.id) : null}
      >
        <div>
          <em>{feed.branch ? feed.branch.name : ''}</em>
          <span>{calculateTimeStamp(feed.created_at)}</span>
        </div>
        <i>EVENT</i>
        <strong>{feed.title}</strong>
        {!detail && (
          <Container>
            <div
              style={textClass}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </Container>
        )}
        {feed.end_at !== null ? <p>{getEndEventTime(feed.end_at)}</p> : null}
      </a>
    </div>
  );
};

export default EventCard;
